module.exports = __webpack_public_path__ + "static/media/logos_squares_CoOrg_HKSTP_SC.2e8b43e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_CoOrg_HKSTP_SC.png
// module id = 39
// module chunks = 0